import { BaseSerializer } from './base.serializer'
import { OnlineLearningRegistration, OnlineLearningRegistrationData } from 'models'

export class OnlineLearningRegistrationDataSerializer extends BaseSerializer<OnlineLearningRegistrationData> {
  static SERIALIZABLE_ATTRIBUTES = [
    'centerId',
    'country',
    'driverId',
    'driverLicense',
    'driverCity',
    'examPassed',
    'firstName',
    'hubModerationCourse',
    'hubModerationId',
    'lastName',
    'licenseNumber',
    'locale',
    'mechanics',
    'middleName',
    'phone',
    'programId',
    'scheduledAt',
    'target',
    'tariffName',
    'uuid',
    'rating'
  ]

  static SERIALIZERS = {}

  static SERIALIZE_RENAME_KEYS = {}

  static DESERIALIZERS = {}

  static DESERIALIZE_RENAME_KEYS = {}

  static initializeObject(attributes: Object): OnlineLearningRegistrationData {
    return attributes as OnlineLearningRegistrationData
  }
}

export class OnlineLearningRegistrationSerializer extends BaseSerializer<OnlineLearningRegistration> {
  static SERIALIZABLE_ATTRIBUTES = ['uuid', 'data', 'createdAt', 'updatedAt']

  static SERIALIZERS = {
    data: OnlineLearningRegistrationDataSerializer
  }

  static SERIALIZE_RENAME_KEYS = {}

  static DESERIALIZERS = {
    data: OnlineLearningRegistrationDataSerializer
  }

  static DESERIALIZE_RENAME_KEYS = {}

  static initializeObject(attributes: Object): OnlineLearningRegistration {
    return new OnlineLearningRegistration(attributes)
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/serializers/online-learning-registration.serializer.ts